// @flow

import {ThemeProvider, themeTokens} from '@travel-frontend/themes';
import {useSelector} from 'react-redux';

import {isAccessibilityToggleEnabled} from 'redux/uiState/accessibility/reducer';

export const ThemeWrapper = ({portalShort, children}) => {
  const isEnabled = useSelector(isAccessibilityToggleEnabled);

  return (
    <ThemeProvider
      themeTokens={themeTokens[portalShort]}
      isAccessibleTheme={isEnabled}
    >
      {children}
    </ThemeProvider>
  );
};
